// Module
var code = "<h2 class=\"heading--isInteriorPageSubHeading\"> Get the Help You Need When You Need It </h2> ";
// Exports
export default code;